import { Component, OnInit } from '@angular/core';
import { ChecklistService } from '../checklist-service/checklist.service';
import { sweetAlert } from 'src/app/utils/swal';
import { takeUntilDestroyed } from 'src/app/utils/take-until-destroyed';
import { takeUntil } from 'rxjs/operators';
import { LevelOfServiceService } from '../../level-of-service/service/level-of-service.service';

@Component({
  selector: 'app-checklist',
  templateUrl: './checklist.component.html',
  styleUrls: ['./checklist.component.css']
})
export class ChecklistComponent implements OnInit {
checklistData = [];
selectedStatus ='active'
search;
preSpaceType: any = {};

  constructor(
    private checklistService:ChecklistService,
    private levelOfServiceService: LevelOfServiceService
  ) { }

  ngOnInit() {
    this.getChecklists();
  }

  getChecklists(){
    this.checklistService.getCheckList()
      .pipe(takeUntil(takeUntilDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.checklistData = data;
        }
      }, err => {
        sweetAlert('Error', err, 'warning', 'OK');
      });
    this.getSpaceTypeList();

  }

  getSpaceTypeList() {
    this.levelOfServiceService
      .getSpaceTypes({ status: 'active' })
      .pipe(takeUntil(takeUntilDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.preSpaceType = data.reduce((obj, item) => (obj[item._id] = item, obj), {});

        }
      }, err => {
        sweetAlert('Error', err, 'warning', 'OK');
      });
  }

  onChangeStatus(){

  }
  ngOnDestroy(): void {
  }

}
